import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=44b4fa30&"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports